import { McpSetupGuideTab } from "../../components/McpSetupGuide/mcp-setup-guide-tab";
import { McpWizardModalProvider } from "../../components/McpWizardModalProvider";

// // // //

/**
 * McpPage
 * MCP setup guide with connect wizard modal.
 */
export function McpPage() {
    return (
        <div className="mt-6">
            <McpWizardModalProvider>
                {({ openWizard }) => (
                    <McpSetupGuideTab onConnect={openWizard} />
                )}
            </McpWizardModalProvider>
        </div>
    );
}
